"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var TopLevelNavNodes;
        (function (TopLevelNavNodes) {
            TopLevelNavNodes[TopLevelNavNodes["favorites"] = 0] = "favorites";
            TopLevelNavNodes[TopLevelNavNodes["recents"] = 1] = "recents";
            TopLevelNavNodes[TopLevelNavNodes["workspaces"] = 2] = "workspaces";
            TopLevelNavNodes[TopLevelNavNodes["modules"] = 3] = "modules";
        })(TopLevelNavNodes = DynReact.TopLevelNavNodes || (DynReact.TopLevelNavNodes = {}));
        var DynModuleStore = /** @class */ (function () {
            function DynModuleStore() {
                this._collapsedMenus = [];
                this.maxRecents = 10;
                this.hasAnyPersonalizations = false;
                this._activeModuleMenuItem = null;
                this.hideWhatsNew = false;
                this._lastActiveModuleMenuItem = null;
                this.mainMenuName = "mainmenu";
                this.AOTMainMenuName = "\\Menus"; // this is for passing personalization for module information, must have the \\ at the start.
                this.navPaneMenuName = "navpanemenu";
                this.navPanePersonalizationName = "navpane";
                this._subscriptions = [];
                this._modules = {};
                this._itemsById = {};
                this._favoritesLoaded = false;
                this._favoritesLoading = true;
                this.hasFavorites = null;
                this._recentsLoaded = false;
                this._recentsLoading = true;
                this._recents = [];
                this._modulesLoaded = false;
                this._workspacesLoaded = false;
                this._workspacesLoading = true;
                this._loading = false;
                this._pendingRaise = false;
                this._pendingFormCrumb = null;
                this._modulesLoading = true;
            }
            DynModuleStore.prototype.reset = function () {
                var _this = this;
                this._modules = {};
                this._itemsById = {};
                this._favoritesLoaded = false;
                this._recentsLoaded = false;
                this._recents = [];
                this._modulesLoaded = false;
                this._workspacesLoaded = false;
                this._activeModuleMenuItem = null;
                // dont load until the initial form is requested
                $dyn.deferred.onTrue(function () { return $dyn.value($dyn.shell.clientInitialFormRequested); }).done(function () {
                    _this._loadModules();
                    _this._loadWorkspaces();
                    _this.getRecents();
                    _this._modulesLoaded = true;
                    _this._workspacesLoaded = true;
                });
            };
            DynModuleStore.prototype._requestMenuStructure = function (targetId, callback, options) {
                $dyn.logWarning("_requestMenuStructure must be implemented.");
                // There is no default implementation for request menu structure. This function must be
                // replaced by server form, test scenarios, or other webclient consumer.
            };
            DynModuleStore.prototype.requestMenuForPath = function (path, callback) {
                if (path[0] === this.mainMenuName) {
                    this._loadLinks(path[1], callback);
                }
                else {
                    this._loadWorkspaces(callback);
                }
            };
            DynModuleStore.prototype.whatsNewClose = function () {
                this.hideWhatsNew = true;
                $dyn.whatsNew.closeWhatsNew($dyn.whatsNew.keyIds.navigationKey);
            };
            DynModuleStore.prototype.addSubscription = function (callback) {
                this._subscriptions.push(callback);
            };
            DynModuleStore.prototype.removeSubscription = function (callback) {
                var index = this._subscriptions.indexOf(callback);
                if (index >= 0) {
                    this._subscriptions.splice(index, 1);
                }
            };
            DynModuleStore.prototype.menuExpandCollapseAll = function (links, value) {
                this._updateNavigationStateAll(links, value);
                this._raise();
            };
            DynModuleStore.prototype.changeActiveModule = function (menuItem, postChangeFunction) {
                if (menuItem !== this._activeModuleMenuItem) {
                    if (menuItem == null) {
                        this._lastActiveModuleMenuItem = this._activeModuleMenuItem;
                    }
                    if (menuItem && !this._modules[menuItem]) {
                        menuItem = null;
                    }
                    if (menuItem && !this._modules[menuItem].children) {
                        this._activeModuleMenuItem = null; // Clear the current module until data is received.
                        this._modules[menuItem].children = [];
                        this._loadLinks(menuItem, postChangeFunction);
                    }
                    else {
                        this._activeModuleMenuItem = menuItem;
                        $dyn.applyFunction(postChangeFunction);
                        this._raise();
                    }
                }
            };
            DynModuleStore.prototype.getActiveLinks = function () {
                if (this._activeModuleMenuItem) {
                    return this._modules[this._activeModuleMenuItem].children;
                }
                return [];
            };
            DynModuleStore.prototype.getActiveModuleLabel = function () {
                for (var key in this._modules) {
                    if (this._modules[key].menuItem === this._activeModuleMenuItem) {
                        return this._modules[key].label;
                    }
                }
                return "";
            };
            DynModuleStore.prototype.isActiveModule = function (menuItem) {
                var activeMenu = false;
                if (menuItem === this._activeModuleMenuItem) {
                    activeMenu = true;
                }
                else if (menuItem === this._lastActiveModuleMenuItem) {
                    // reset last module
                    this._lastActiveModuleMenuItem = null;
                    activeMenu = true;
                }
                return activeMenu;
            };
            DynModuleStore.prototype.getModules = function () {
                if (!this._modulesLoaded) {
                    this._loadModules();
                    this._modulesLoaded = true;
                }
                return this._modules;
            };
            DynModuleStore.prototype.getItemById = function (id) {
                return this._itemsById[id] || {};
            };
            DynModuleStore.prototype.getLoadingState = function () {
                return this._loading;
            };
            DynModuleStore.prototype.getNodeLoadingState = function (nodeItem) {
                var loadingState;
                switch (nodeItem) {
                    case TopLevelNavNodes.favorites:
                        loadingState = this._favoritesLoading;
                        break;
                    case TopLevelNavNodes.recents:
                        loadingState = this._recentsLoading;
                        break;
                    case TopLevelNavNodes.workspaces:
                        loadingState = this._workspacesLoading;
                        break;
                    case TopLevelNavNodes.modules:
                        loadingState = this._modulesLoading;
                        break;
                    default:
                        loadingState = true;
                }
                return loadingState;
            };
            DynModuleStore.prototype.getRecents = function () {
                if (!this._recentsLoaded) {
                    this._loadUserMenuItems("RetrieveRecentlyUsedMenuItems", { recent: true });
                    this._recentsLoaded = true;
                }
                // only return first maxRecents items
                return this._recents.slice(0, this.maxRecents);
            };
            DynModuleStore.prototype.getFavorites = function () {
                if (!this._favoritesLoaded) {
                    this._loadUserMenuItems("RetrieveFavoriteMenuItems", { favorite: true });
                    this._favoritesLoaded = true;
                }
                var favs = [];
                for (var key in this._itemsById) {
                    if (this._itemsById[key].favorite) {
                        favs.push(this._itemsById[key]);
                    }
                }
                favs.sort(this.compareLabel);
                this.hasFavorites = favs.length > 0 ? true : false;
                return favs;
            };
            DynModuleStore.prototype.getWorkspaces = function (navigationModeIsWorkspace) {
                if (!this._workspacesLoaded) {
                    this._loadWorkspaces();
                    this._workspacesLoaded = true;
                }
                var workspaces = [];
                for (var key in this._itemsById) {
                    if (this._itemsById[key].workspace) {
                        workspaces.push(this._itemsById[key]);
                    }
                }
                if (!navigationModeIsWorkspace) {
                    workspaces.sort(this.compareLabel);
                }
                return workspaces;
            };
            // Expansion state is stored here instead of inside the control itself because it enables
            // it to be controlled externally, (ex. personalization).
            DynModuleStore.prototype.setExpanded = function (id, expanded) {
                this._itemsById[id].expanded = expanded;
                this._sendPersonalizationState(this._itemsById[id].aotPath, "expanded", expanded);
                this._raise();
            };
            DynModuleStore.prototype.setFavorite = function (id, favorite) {
                var item = this._itemsById[id];
                item.favorite = favorite;
                var crumb = this.getNavigationPath(item.id);
                var operation = favorite ? "AddFavoriteMenuItem" : "RemoveFavoriteMenuItem";
                this._requestMenuStructure(operation, function () { }, { menuItem: item.id + "#" + crumb });
                this._raise();
            };
            DynModuleStore.prototype.addRecentlyUsedItem = function (id) {
                if (!this._itemsById[id].recent) {
                    this._itemsById[id].recent = true;
                    // add to recents list if this is new
                    if (this._recents.indexOf(this._itemsById[id]) === -1) {
                        this._recents.unshift(this._itemsById[id]);
                        // are there more than more than maxrecents items per the module
                        this.removeExcessModuleRecents(this._itemsById[id].module);
                    }
                }
                else {
                    // reposition to the top
                    this._recents.splice(this._recents.indexOf(this._itemsById[id]), 1);
                    this._recents.unshift(this._itemsById[id]);
                }
                this._raise();
            };
            DynModuleStore.prototype.updateFormCrumbs = function (formName) {
                // check if the form matches the first form in the recents
                if (!$dyn.restrictedNavigation && this._recents[0]) {
                    if (formName === this._recents[0].formName) {
                        var crumb = this.getNavigationPath(this._recents[0].id);
                        if ($dyn.ui.getNavBar()) {
                            $dyn.ui.getNavBar().Crumbs(crumb);
                        }
                    }
                    this._pendingFormCrumb = null;
                }
                else {
                    this._pendingFormCrumb = formName;
                }
            };
            DynModuleStore.prototype.getNavigationPath = function (id) {
                // array of the items
                var item = this.getItemById(id);
                var crumbs;
                var nextItem;
                if (item.crumb) {
                    // return stored crumb without the item itself in it.
                    var tmpCrumb = JSON.stringify(item.crumb);
                    crumbs = JSON.parse(tmpCrumb);
                    return crumbs;
                }
                // no stored crumb so build it
                crumbs = [item.label];
                nextItem = item.parent;
                while (nextItem) {
                    crumbs.unshift(nextItem.label);
                    nextItem = nextItem.parent;
                }
                return crumbs;
            };
            /**
             * Entry point for navigation that wants to notify the NavBar and NavPane of the action
             * @description Updates recents and breadcrumbs. An example consumer is found in the SearchBox.
             * @param navItem The nav item to navigate to
             * @internal
             */
            DynModuleStore.prototype.startNavigation = function (navItem) {
                $dyn.ui.getNavBar().clearCrumb();
                if (navItem.MenuItemType && navItem.MenuItemName) {
                    navItem.menuItem = navItem.MenuItemType + ":" + navItem.MenuItemName;
                }
                else {
                    navItem.menuItem = navItem.MenuItemName;
                }
                if (!navItem.navigationItemId) {
                    navItem.NavigationPath[0] = navItem.NavigationPath[0].toLowerCase();
                    if (navItem.NavigationPath[0] === this.navPaneMenuName) {
                        // workspaces are flattened in the nav pane, remove the module
                        navItem.NavigationPath.splice(1, 1);
                    }
                    navItem.navigationItemId = navItem.MenuItemName + "#" + navItem.MenuItemType + "#[\"" + navItem.NavigationPath.join('","') + "\"]";
                }
                navItem.elementCreated = $dyn.serverForm.getForm;
                navItem.updateQuery = true;
                $dyn.telemetry.addNavigationEvent(navItem.navigationFeatureName, navItem.menuItem, navItem.NavigationPath);
                this.navigate(navItem);
            };
            DynModuleStore.prototype.saveMenuPaneSettings = function (pinState) {
                /// future can modify this to provide more than just pinState
                this._requestMenuStructure("StoreMenuPaneSettings", function () { }, { state: "pinState#" + pinState });
            };
            DynModuleStore.prototype.getMenuPaneSettings = function (callBack) {
                var _this = this;
                /// future can modify this to provide more than just pinState
                $dyn.async(function () {
                    _this._requestMenuStructure("GetMenuPaneSettings", function (result) {
                        callBack(result);
                    });
                });
            };
            DynModuleStore.prototype._raise = function () {
                var e_1, _a;
                try {
                    for (var _b = __values(this._subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var subscription = _c.value;
                        subscription();
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            };
            DynModuleStore.prototype._raiseDeferred = function () {
                var _this = this;
                if (this._pendingRaise) {
                    return;
                }
                this._pendingRaise = true;
                $dyn.async(function () {
                    _this._pendingRaise = false;
                    _this._raise();
                });
            };
            DynModuleStore.prototype._getModuleFromPath = function (path) {
                var ret = "";
                if (path) {
                    var module_1 = JSON.parse(path);
                    if (module_1.slice(0, 1) === this.mainMenuName) {
                        ret = module_1.slice(1, 2)[0];
                    }
                    else {
                        ret = "workspace";
                    }
                }
                return ret;
            };
            DynModuleStore.prototype._loadModules = function () {
                var _this = this;
                $dyn.async(function () {
                    _this._modulesLoading = true;
                    _this._requestMenuStructure("RetrieveNavigationPaneTopLevelSitemapMenu", function (result) {
                        var e_2, _a;
                        var newStructure = {};
                        var parsedStructure;
                        if (result) {
                            if (!$.isPlainObject(result)) {
                                // TODO = The wrong value type is being used for the callback, should be serialized
                                parsedStructure = JSON.parse(result);
                            }
                            else {
                                parsedStructure = result;
                            }
                            if (parsedStructure) {
                                var sections = parsedStructure.GetDataContract;
                                try {
                                    for (var sections_1 = __values(sections), sections_1_1 = sections_1.next(); !sections_1_1.done; sections_1_1 = sections_1.next()) {
                                        var element = sections_1_1.value;
                                        newStructure[element.getMenuItemName] = { label: element.getTitleStr, menuItem: element.getMenuItemName, id: element.getName || element.getMenuItemName };
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (sections_1_1 && !sections_1_1.done && (_a = sections_1.return)) _a.call(sections_1);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                        }
                        _this._modules = newStructure;
                        _this._modulesLoading = false;
                        _this._raiseDeferred();
                    });
                });
            };
            DynModuleStore.prototype._loadUserMenuItems = function (action, props) {
                var _this = this;
                $dyn.async(function () {
                    if (props.recent) {
                        _this._recentsLoading = true;
                    }
                    if (props.favorite) {
                        _this._favoritesLoading = true;
                    }
                    _this._requestMenuStructure(action, function (result) {
                        var e_3, _a;
                        var parsedStructure;
                        if (result) {
                            if (!$.isPlainObject(result)) {
                                // Result descriptor had an incorrect value type.
                                parsedStructure = JSON.parse(result);
                            }
                            else {
                                parsedStructure = result;
                            }
                            if (parsedStructure && parsedStructure.GetDataContract) {
                                try {
                                    for (var _b = __values(parsedStructure.GetDataContract), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        var item = _c.value;
                                        var id = item.getMenuItemName + "#" + item.getMenuItemType + "#" + item.getNavigationPath;
                                        var crumb = null;
                                        if (item.getCrumbPath) {
                                            crumb = item.getCrumbPath.split(",");
                                        }
                                        var module_2 = _this._getModuleFromPath(item.getNavigationPath);
                                        if (!_this._itemsById[id]) {
                                            _this._itemsById[id] = { label: item.getTitleStr, menuItem: item.getMenuItemName, menuItemType: item.getMenuItemType, formName: item.getFormName, crumb: crumb, id: id, module: module_2 };
                                        }
                                        _this._assign(_this._itemsById[id], props);
                                        if (props.recent) {
                                            _this._recents.push(_this._itemsById[id]);
                                        }
                                    }
                                }
                                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    }
                                    finally { if (e_3) throw e_3.error; }
                                }
                                if (props.recent && _this._recents && _this._pendingFormCrumb) {
                                    _this.updateFormCrumbs(_this._pendingFormCrumb);
                                }
                                if (props.recent) {
                                    _this._recentsLoading = false;
                                }
                                if (props.favorite) {
                                    _this._favoritesLoading = false;
                                }
                                _this._raiseDeferred();
                            }
                        }
                    });
                });
            };
            DynModuleStore.prototype._loadWorkspaces = function (postLoadFunction) {
                var _this = this;
                $dyn.async(function () {
                    _this._workspacesLoading = true;
                    _this._requestMenuStructure("RetrieveNavigationPaneMenu", function (result) {
                        var e_4, _a, e_5, _b;
                        var parsedStructure;
                        if (result) {
                            if (!$.isPlainObject(result)) {
                                // Result descriptor had an incorrect value type.
                                parsedStructure = JSON.parse(result);
                            }
                            else {
                                parsedStructure = result;
                            }
                            if (parsedStructure && parsedStructure.GetDataContract) {
                                try {
                                    for (var _c = __values(parsedStructure.GetDataContract), _d = _c.next(); !_d.done; _d = _c.next()) {
                                        var outerItem = _d.value;
                                        try {
                                            for (var _e = (e_5 = void 0, __values(outerItem.GetDataContract)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                                var item = _f.value;
                                                var id = item.getMenuItemName + "#" + item.getMenuItemType + "#[\"" + _this.navPaneMenuName + "\",\"" + item.getMenuItemName + "\"]";
                                                _this._itemsById[id] = {
                                                    formName: item.getFormName,
                                                    id: id,
                                                    image: item.getImageStr,
                                                    imageType: item.getImageLocationStr,
                                                    label: item.getTitleStr,
                                                    menuItem: item.getMenuItemName,
                                                    menuItemType: item.getMenuItemType,
                                                    workspace: true,
                                                };
                                            }
                                        }
                                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                        finally {
                                            try {
                                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                            }
                                            finally { if (e_5) throw e_5.error; }
                                        }
                                    }
                                }
                                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                finally {
                                    try {
                                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                    }
                                    finally { if (e_4) throw e_4.error; }
                                }
                                _this._workspacesLoading = false;
                                $dyn.applyFunction(postLoadFunction);
                                _this._raiseDeferred();
                            }
                        }
                    });
                });
            };
            DynModuleStore.prototype._loadLinks = function (menuItem, postLoadFunction) {
                var _this = this;
                // in the case of search returning a menu item for a menu we dont have rendered - check existence
                // this can happen if showparentModule = no which will filter out top level Menu, search does not filter out of the results
                if (!(menuItem in this._modules)) {
                    return;
                }
                this._loading = true;
                $dyn.async(function () {
                    _this._requestMenuStructure("RetrieveSitemapMenu", function (result) {
                        var parsedStructure;
                        if (result) {
                            if (!$.isPlainObject(result)) {
                                // Result descriptor had an incorrect value type.
                                parsedStructure = JSON.parse(result);
                            }
                            else {
                                parsedStructure = result;
                            }
                            if (!parsedStructure) {
                                // Shouldn't happen, but don't break if it does
                                return;
                            }
                            var processList_1 = function (children, parent, level, path, _aotPath) {
                                var e_6, _a;
                                var list = [];
                                try {
                                    for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                                        var child = children_1_1.value;
                                        var name_1 = child.getMenuItemName || child.getName;
                                        var aotPath = _aotPath.slice();
                                        var newPath = path.slice();
                                        newPath.push(name_1);
                                        aotPath.push(name_1);
                                        var stringifyPath = JSON.stringify(newPath);
                                        var id = child.getMenuItemName + "#" + child.getMenuItemType + "#" + stringifyPath;
                                        var item = _this._itemsById[id] || {};
                                        item.id = id;
                                        item.aotPath = aotPath.toString().replace(/,/g, "\\"); // replace , with \\ for AOT usage.
                                        item.label = child.getTitleStr;
                                        item.tile = child.getTileName;
                                        item.image = child.getImageStr;
                                        item.imageType = child.getImageLocationStr;
                                        item.menuItem = child.getMenuItemName;
                                        item.menuItemType = child.getMenuItemType;
                                        item.formName = child.getFormName;
                                        item.parent = parent;
                                        item.expanded = child.getExpandState ? true : false; // TODO: Is this correct?
                                        item.module = _this._getModuleFromPath(stringifyPath);
                                        // tslint:disable-next-line:triple-equals
                                        if (child.getHasAnyNavPanePersonalizationsBoolean || child.getHasAnyNavPanePersonalizationsBoolean == false) {
                                            _this.hasAnyPersonalizations = child.getHasAnyNavPanePersonalizationsBoolean;
                                        }
                                        if (child.GetDataContract) {
                                            item.children = processList_1(child.GetDataContract, item, level + 1, newPath, aotPath);
                                            if (_this.hasAnyPersonalizations) {
                                                if (child.getExpandState.toUpperCase() === "TRUE") {
                                                    item.expanded = true;
                                                }
                                                else if (child.getExpandState.toUpperCase() === "FALSE") {
                                                    item.expanded = false;
                                                }
                                            }
                                            else if (level === 0 && child.getName === "Workspaces") {
                                                item.expanded = true;
                                            }
                                        }
                                        _this._itemsById[item.id] = item;
                                        list.push(item);
                                    }
                                }
                                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                finally {
                                    try {
                                        if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                                    }
                                    finally { if (e_6) throw e_6.error; }
                                }
                                return list;
                            };
                            if (_this._modules && _this._modules[menuItem]) {
                                _this._modules[menuItem].children = processList_1(parsedStructure.GetDataContract, _this._modules[menuItem], 0, [_this.mainMenuName, menuItem], [menuItem]);
                                _this._activeModuleMenuItem = menuItem;
                            }
                            _this._loading = false;
                            $dyn.applyFunction(postLoadFunction);
                            _this._raise();
                        }
                    }, { menuItem: menuItem });
                });
            };
            DynModuleStore.prototype._assign = function (target, props) {
                // tslint:disable-next-line:forin
                for (var key in props) {
                    target[key] = props[key];
                }
            };
            DynModuleStore.prototype._updateNavigationStateAll = function (links, expanding) {
                var e_7, _a;
                try {
                    for (var links_1 = __values(links), links_1_1 = links_1.next(); !links_1_1.done; links_1_1 = links_1.next()) {
                        var item = links_1_1.value;
                        if (!item.menuItemType) { // implies group
                            item.expanded = expanding;
                            this._sendPersonalizationState(item.aotPath, "expanded", item.expanded);
                        }
                        if (item.children && item.children.length) {
                            this._updateNavigationStateAll(item.children, expanding);
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (links_1_1 && !links_1_1.done && (_a = links_1.return)) _a.call(links_1);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            };
            DynModuleStore.prototype._sendPersonalizationState = function (itemId, property, state) {
                var _this = this;
                $dyn.async(function () {
                    $dyn.callFunction($dyn.user().SetCustomObjectPersonalization, undefined, [_this.navPanePersonalizationName, itemId, property, state]);
                }, undefined, "Update Menu Expand State");
            };
            DynModuleStore.prototype.removeExcessModuleRecents = function (module) {
                var _this = this;
                var loop = 0;
                var id = "";
                // $dyn.React.ModuleStore.activeModule = this.state.activeLinks[0].parent.id
                var filterModuleList = this._recents.filter(function (obj) { return obj.module === module; });
                if (filterModuleList.length > this.maxRecents) {
                    filterModuleList = filterModuleList.slice(this.maxRecents);
                    // first loop clears the recent flag for display
                    while (loop < filterModuleList.length) {
                        id = filterModuleList[loop].id;
                        this._itemsById[id].recent = false;
                        loop = loop + 1;
                    }
                    // second loop processes server call
                    window.setTimeout(function () {
                        loop = 0;
                        while (loop < filterModuleList.length) {
                            id = filterModuleList[loop].id;
                            _this._requestMenuStructure("RemoveRecentMenuItem", function () { }, { menuItem: id });
                            loop = loop + 1;
                        }
                    });
                }
            };
            DynModuleStore.prototype.compareLabel = function (a, b) {
                return (a.label.localeCompare(b.label, Globalize.culture().name));
            };
            DynModuleStore.prototype.navigate = function (options) {
                // This function can be overridden to replace shell navigation
                $dyn.shell.navigateToForm(options);
            };
            return DynModuleStore;
        }());
        DynReact.ModuleStore = new DynModuleStore();
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModuleStore.js.map
